import React from "react";

import { EstadoAlumno, FormaDeEntrega } from "../../../../services/v2/classPortal.service";
import { Icono } from "../comun";

/*
	Piezas que comparten las pantallas de tareas del personal y del alumno (Portal de Clase, Parte B).
	Lo atrasado y lo que está por debajo de 70 va en oro (nunca rojo); el naranja marca lo que espera una acción.
*/

/** Solo de respaldo: la nota mínima la manda el servidor (`minGrade`) y, donde llega, se usa esa. */
export const NOTA_MINIMA = 70

/** Quita ceros de más: 12 → "12", 12.5 → "12.5". */
export const puntosTxt = (n: number): string => String(Math.round(n * 100) / 100)

export const esNotaBaja = (puntos: number, maximo: number, minimo: number = NOTA_MINIMA): boolean => maximo > 0 && (puntos / maximo) * 100 < minimo

export const IconoEntrega: React.FC<{ forma: FormaDeEntrega; size?: number }> = ({ forma, size = 20 }) => (
	<Icono n={forma === "foto" ? "camara" : forma === "en_clase" ? "lugar" : forma === "quiz" ? "pregunta" : "doc"} size={size} />
)

export const textoEntrega = (forma: FormaDeEntrega): string =>
	forma === "foto" ? "Entrega Con Foto" : forma === "archivo" ? "Entrega Con Archivo" : forma === "en_clase" ? "Práctica En Clase" : forma === "quiz" ? "Quiz" : "Solo Lectura"

export const ESTADO_ALUMNO: Record<EstadoAlumno, { texto: string; clase: string }> = {
	pendiente: { texto: "Pendiente", clase: "pcChipBorde" },
	atrasada: { texto: "Atrasada", clase: "pcChipOro" },
	cerrada: { texto: "Cerrada", clase: "pcChipOro" },
	entregada: { texto: "Entregada", clase: "tkChipOscuro" },
	repetir: { texto: "Repetir", clase: "pcChipOro" },
	devuelta: { texto: "Calificada", clase: "pcChipAcento" },
	en_clase: { texto: "Se Califica En Clase", clase: "" },
	lectura: { texto: "Solo Lectura", clase: "" },
	quiz: { texto: "Por Hacer", clase: "pcChipBorde" },
}

/** Etiqueta de un alumno: "18 / 20" (en oro si queda por debajo de 70 %) o el estado. */
export const ChipEstadoAlumno: React.FC<{ estado: EstadoAlumno; score: number | null; scoreHidden: boolean; max: number; minimo?: number }> = ({ estado, score, scoreHidden, max, minimo }) => {
	if (estado === "devuelta" && score !== null) {
		return <span className={"pcChip " + (esNotaBaja(score, max, minimo) ? "pcChipOro" : "pcChipAcento")}>{puntosTxt(score)} / {puntosTxt(max)}</span>
	}
	const e = ESTADO_ALUMNO[estado]
	return <span className={"pcChip " + e.clase}>{estado === "devuelta" && scoreHidden ? "Devuelta" : e.texto}</span>
}
